// src/config/env.js

const stripSlash = (s) => String(s || "").replace(/\/$/, "");

export const env = {
  AUTH_BASE_URL: stripSlash(process.env.REACT_APP_AUTH_BASE_URL),
  
  WAREHOUSE_BASE_URL: stripSlash(process.env.REACT_APP_WAREHOUSE_BASE_URL),

  // RBAC microservice
  RBAC_BASE_URL: stripSlash(process.env.REACT_APP_AUTH_BASE_URL),

  // Catalog microservice
  CATALOG_BASE_URL: stripSlash(process.env.REACT_APP_CATALOG_BASE_URL),

  // Warehouse Inventory microservice
   WAREHOUSE_INVENTORY_BASE_URL:stripSlash(process.env.REACT_APP_WAREHOUSE_INVENTORY_BASE_URL),


  USER_BASE_URL: stripSlash(process.env.REACT_APP_USER_BASE_URL),

  DELIVERY_PARTNER_BASE_URL: stripSlash(process.env.REACT_APP_DELIVERY_PARTNER_BASE_URL),
  
  GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "",

  REPORT_BASE_URL: stripSlash(process.env.REACT_APP_REPORT_BASE_URL || "http://localhost:7102"),

  SUPPORT_BASE_URL: stripSlash(process.env.REACT_APP_USER_BASE_URL),

  ORDER_BASE_URL: stripSlash(process.env.REACT_APP_ORDER_BASE_URL || process.env.REACT_APP_AUTH_BASE_URL),
   
  // New production restaurant app microservice
  RESTAURANT_APP_BASE_URL: stripSlash(process.env.REACT_APP_RESTAURANT_APP_BASE_URL || "http://localhost:6040"),
  
};